<div *ngIf="show" class="loading-indicator">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
